import { AutoResizingTextarea } from "../auto-resizing-textarea"

interface QuestionTextInputProps {
  value: string | undefined
  onChange: (value: string) => void
  disabled?: boolean
  placeholder?: string
}

export function QuestionTextInput({
  value,
  onChange,
  disabled,
  placeholder = "Type your answer…",
}: QuestionTextInputProps) {
  return (
    <AutoResizingTextarea
      value={value ?? ""}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      disabled={disabled}
      rows={1}
      className="w-full rounded-lg border border-input px-3 py-1.5 text-sm leading-4 focus:border-current"
    />
  )
}
